import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics'
import type { Plugin } from 'vue'
import { isCanonicalTrackingEnabled } from '~/composables/canonicalTracking'

export const webAnalyticsPlugin: Plugin = {
  install(_app, _options) {
    const firebaseConfig = {
      apiKey: import.meta.env.VITE_WEB_FIREBASE_ANALYTICS_API_KEY,
      authDomain: import.meta.env.VITE_WEB_FIREBASE_ANALYTICS_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_WEB_FIREBASE_ANALYTICS_PROJECT_ID,
      storageBucket: import.meta.env.VITE_WEB_FIREBASE_ANALYTICS_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_WEB_FIREBASE_ANALYTICS_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_WEB_FIREBASE_ANALYTICS_APP_ID,
      measurementId: import.meta.env.VITE_WEB_FIREBASE_ANALYTICS_MEASUREMENT_ID
    }

    // Web events use the parent bridge or canonical /events transport when sGTM
    // is enabled. Initialising Firebase here would load Google's gtag.js directly,
    // bypassing the first-party script-serving and event-collection paths.
    if (!isPlatform('capacitor') && !isCanonicalTrackingEnabled()) {
      FirebaseAnalytics.initializeFirebase(firebaseConfig)
    }
  }
}
